import React from 'react'
import LoginButton from './LoginButton'
import { siteDefaultErrMsg } from 'modules/siteContents'

/** Stripe ACH migration: show message only (Chinese copy set in paymentActions.normalizePaymentRequestError). */
const STRIPE_PAYMENT_MIGRATION_CODES = new Set([
  'SUBSCRIPTION_PAYMENT_METHOD_REBIND_REQUIRED',
  'SUBSCRIPTION_PAYMENT_METHOD_PM_REQUIRED',
  'legacy_payment_method_not_found',
  'legacy_source_resolve_failed',
])

const RequestError = ({ error, email, saveAppState, profileAuth0, forPlaid, site, initialUrlParams = {} }) => {
  const errorCode = error?.code || error?.errorCode
  const isKnownError = error && errorCode && error.message
  const migrationFriendly = errorCode && STRIPE_PAYMENT_MIGRATION_CODES.has(String(errorCode))
  return (
    <div className="error-message mt1" style={{ color: '#a94442' }}>
      {
        isKnownError ? (
          migrationFriendly ? (
            error.message
          ) : (
            `Error: (${errorCode}) ${error.message}`
          )
        ) : (
          'Unknown Error'
        )
      }
      <br />
      {
        (errorCode === 'E00039' && !profileAuth0) ? (
          <LoginButton
            saveAppState={saveAppState}
            email={email}
            className="btn-donate"
            text={`Try logging in as ${email} first`}
            initialUrlParams={initialUrlParams}
          />
        ) : (isKnownError ? null : <div>{siteDefaultErrMsg[forPlaid ? 'plaid' : 'general'][site] || siteDefaultErrMsg[forPlaid ? 'plaid' : 'general'].default || ''}</div>)
      }
    </div>
  )
}

export default RequestError